export interface IconProps extends React.SVGProps<SVGSVGElement> {
  color?: string;
}

export const SvgIconSwipable = ({ width = 32, height = 10, color = '#868E96', ...props }: IconProps): JSX.Element => {
  return (
    <svg width={width} height={height} viewBox='0 0 34 12' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path d='M1.5 6L33 6' stroke={color} />
      <path d='M6 1L1 6L6 11' stroke={color} />
      <path d='M28 1L33 6L28 11' stroke={color} />
    </svg>
  );
};
